/* eslint-disable react/prop-types */
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Link, { LINK_TYPES } from 'components/Link'
import Icon from 'components/Icon'
import cn from 'classnames'
import './LinkButton.scss'

export const LINK_BUTTON_THEMES = {
    light: 'light',
    outline: 'outline',
    dark: 'dark',
    darkFilled: 'dark-filled',
    outlineDark: 'outline-dark',
}

export const mapLinkTypeToIconName = (linkType) => {
    switch (linkType) {
        case LINK_TYPES.external:
            return 'external';
        case LINK_TYPES.restricted:
            return 'lock';
        case LINK_TYPES.download:
            return 'download-outline';
        case LINK_TYPES.regular:
        default:
            return null;
    }
}

const LinkButton = ({
    className,
    openInNewTab = false,
    url,
    theme = LINK_BUTTON_THEMES.light,
    text,
    type,
    disabled,
    additionalAttributes = {},
    formButtonType,
    fullWidth = false,
    onClick
}) => {
    const RootComponent = url ? 'a' : 'button'

    const props = {
        ...(url && {
            href: url,
            target: openInNewTab ? '_blank' : undefined,
            rel: openInNewTab ? 'noopener noreferrer' : undefined
        }),
        ...(onClick && typeof onClick === 'function' && !disabled && { onClick }),
        ...(!url && {
            'disabled': !!disabled
        }),
        ...(formButtonType && {
            'type': formButtonType
        }),
        ...additionalAttributes
    }

    const linkIcon = useMemo(() => mapLinkTypeToIconName(type), [type]);

    return (
        <RootComponent
            className={cn(
                'link-button',
                `link-button_theme-${theme}`,
                className, 
                {
                    [`link-button_fullwidth`]: fullWidth,
                }
            )}
            {...props}
        >
            {text && <span className={cn('link-button__text')}>{text}</span>}
            {linkIcon && <Icon use={linkIcon} className="link-button__icon" />}
        </RootComponent>
    )
}

LinkButton.propTypes = Object.assign({}, Link.propTypes, {
    additionalAttributes: PropTypes.object,
    theme: PropTypes.oneOf(Object.values(LINK_BUTTON_THEMES)),
    fullWidth: PropTypes.bool,
    onClick: PropTypes.func
})

LinkButton.meta = 'exclude'

export default LinkButton
